$(function(){
    if($('[data-summary]').length < 1){
        return;
    } else {
        $('[data-summary]').on('ifChanged', function(){
            $('.b-rating-sum').each(function(){
                if($('[data-summary]:checked').length > 0) {
                    var total = 0;
                    $('[data-summary]:checked').each(function(){
                        total += parseInt($(this).val());
                    });
                    total = total/$('[data-summary]:checked').length;
                    $('.b-rating-sum__sum').text(total.toFixed(2));
                }
            });
        })
    }
});